import React, { useEffect } from 'react'
import { Loading } from '../components'
import { useDispatch } from 'react-redux'
import { deleteAuthInfo } from '../state/auth'
export const LogoutPage = (props) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(deleteAuthInfo())
  }, [dispatch])
  return <Loading />
}
